var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationFooterIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0833 10.5002C10.75 10.5002 11.3333 10.2502 11.75 9.75016C12.25 9.25016 12.4167 8.66683 12.4167 8.0835C12.4167 7.50016 12.1667 6.8335 11.6667 6.41683C11.1667 5.91683 10.5833 5.75016 10 5.75016C9.41667 5.75016 8.75 6.00016 8.33333 6.50016C7.83333 7.00016 7.66667 7.5835 7.66667 8.16683C7.66667 8.75016 7.91667 9.41683 8.41667 9.8335C8.91667 10.3335 9.5 10.5002 10.0833 10.5002ZM10.0833 19.1668C7.66667 17.0835 5.83333 15.0835 4.58333 13.3335C3.33333 11.5002 2.75 9.8335 2.75 8.3335C2.75 6.0835 3.5 4.3335 4.91667 2.91683C6.33333 1.50016 8.08333 0.833496 10 0.833496C11.9167 0.833496 13.6667 1.50016 15.0833 2.91683C16.5 4.3335 17.25 6.0835 17.25 8.3335C17.25 10.5835 16.6667 11.5002 15.4167 13.3335C14.1667 15.1668 12.4167 17.0835 9.91667 19.1668H10.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFooterIc);
export default __webpack_public_path__ + "static/media/locationFooter_ic.b451721482968983fb57a0bec9e407d9.svg";
export { ForwardRef as ReactComponent };